module.exports = __webpack_public_path__ + "static/img/ta.b2aa6270.svg";